import { createSelector } from '@reduxjs/toolkit';
export const selectDocumentById = (docId)=>({ templates })=>{
        var _templates_document_docId;
        return (_templates_document_docId = templates.document[docId]) === null || _templates_document_docId === void 0 ? void 0 : _templates_document_docId.template;
    };
export const selectSections = (docId, sectionIds)=>({ templates })=>{
        const ids = sectionIds !== null && sectionIds !== void 0 ? sectionIds : [];
        return ids.map((sectionId)=>{
            var _templates_document_docId;
            return (_templates_document_docId = templates.document[docId]) === null || _templates_document_docId === void 0 ? void 0 : _templates_document_docId.sections[sectionId];
        });
    };
export const selectResourceSections = (docId, resourceSectionIds)=>({ templates })=>{
        return resourceSectionIds.map((resourceSectionId)=>{
            var _templates_document_docId;
            return (_templates_document_docId = templates.document[docId]) === null || _templates_document_docId === void 0 ? void 0 : _templates_document_docId.resourceSections[resourceSectionId];
        });
    };
export const selectResourceSectionById = (docId, resourceSectionId)=>({ templates })=>{
        var _templates_document_docId;
        return (_templates_document_docId = templates.document[docId]) === null || _templates_document_docId === void 0 ? void 0 : _templates_document_docId.resourceSections[resourceSectionId];
    };
export const selectAllDocumentResourceSections = (docId)=>({ templates })=>{
        var _templates_document_docId;
        return Object.values(((_templates_document_docId = templates.document[docId]) === null || _templates_document_docId === void 0 ? void 0 : _templates_document_docId.resourceSections) || {});
    };
export const selectAllDocumentResourceSectionsAlt = createSelector((state, docId)=>{
    var _state_templates_document_docId;
    return (_state_templates_document_docId = state.templates.document[docId]) === null || _state_templates_document_docId === void 0 ? void 0 : _state_templates_document_docId.resourceSections;
}, (resourceSections)=>{
    return Object.values(resourceSections || {});
});
// Example usage of selectDocumentById with useSelector
// const docId = 1;
// const documentTemplate = useSelector((state: RootState) => selectDocumentById(docId)(state));
// // Example usage of selectSections with useSelector
// const sectionIds = [1, 2, 3];
// const documentSections = useSelector((state: RootState) => selectSections(docId, sectionIds)(state));
// // Example usage of selectResourceSections with useSelector
// const resourceSectionIds = [1, 2, 3];
// const resourceSections = useSelector((state: RootState) => selectResourceSections(docId, resourceSectionIds)(state));
// // Example usage of selectResourceSectionById with useSelector
// const resourceSectionId = 1;
// const resourceSection = useSelector((state: RootState) => selectResourceSectionById(docId, resourceSectionId)(state));
// // Example usage of selectAllDocumentResourceSections with useSelector
// const allResourceSections = useSelector((state: RootState) => selectAllDocumentResourceSections(state, docId));
export const getDocumentById = (id)=>({ templates })=>{
        var _templates_document_id;
        return (_templates_document_id = templates.document[id]) === null || _templates_document_id === void 0 ? void 0 : _templates_document_id.template;
    };
export const getDocumentTemplateStore = (id)=>({ templates })=>templates.document[id];
